require('../shared/application').setup();

import vogue from 'vogue';
import qs from 'qs';
import React, { Component } from 'react';
import PricingHero from './hero.react';
import config from '../shared/config';


export class Pricing extends Component {
  constructor(props) {
    super(props);

    this.onSelectEssential = this.onSelect.bind(this, 'essential');
    this.onSelectProfessional = this.onSelect.bind(this, 'professional');
    this.onSelectExecutive = this.onSelect.bind(this, 'executive');
  }

  componentWillMount() {
    if (window.location.pathname.includes('pricing')) {
      document.querySelector('.Nav-link--pricing').classList.add('is-bold');
    }
  }

  onSelect(plan) {
    window.location = `${config.endoEndpoint}/link-card?plan=${plan}`;
  }

  render() {
    const queryString = qs.parse(window.location.search.slice(1));
    const conversionFlow = Boolean(queryString.c);

    return (
      <div className="Pricing">
        <div className="container Plans">
          <div className="row">
            <PricingHero conversionFlow={conversionFlow} />
          </div>
        </div>
      </div>
    );
  }
}

vogue.shim({
  Pricing: Pricing,
});
